// extracted by mini-css-extract-plugin
export default {"state":"EmptyState_state__OVxiu","title":"EmptyState_title__v8TKn"};